import React from 'react';

function Footer() {
  return (
    <footer className="p-2 lg:px-0 text-left bg-secondary-blue">
      <div className="max-w-screen-lg mx-auto">
        <div className="container mx-auto flex flex-wrap py-5 flex-col md:flex-row items-center justify-between">
          <div className="lg:w-6/12 inline-flex lg:justify-start text-white text-xs">
            © 2020 Loisy Salvacion. All rights reserved.
          </div>
          <div className="lg:w-6/12 inline-flex lg:justify-end ml-5 lg:ml-0 text-white text-xs">
            <ul className="inline-flex list-disc text-center lg:text-right md:text-center sm:text-center mt-3 text-xs">
              <li className="mr-6 text-white">Code by <a href="https://alvinrapada.com/" target="blank" className="text-yellow-600 underline">Alvin Rapada</a></li>
              <li className="mr-6 text-white">Design by <a href="https://loisysalvacion.netlify.app/" target="blank" className="text-yellow-600 underline">Loisy Salvacion</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
